import _ from "underscore";

import aRouter from "../index";
import get_routes_by_require from "./get_routes_by_require";

import router_distributor_air_ticket_back from "@/router/distributor/air-ticket/back";
import router_distributor_air_ticket_front from "@/router/distributor/air-ticket/front";
import router_distributor_hotel_back from "@/router/distributor/hotel/back";
import router_distributor_hotel_front from "@/router/distributor/hotel/front";

const add_routes = function() {
  const __routes = get_routes_by_require();

  const routes_001 = [
    {
      path: "",
      component: () =>
        import(`@/page/distributor/component/basic-layout/1.0.4/index.vue`),
      children: [
        {
          path: "/",
          name: "root",
          meta: {
            skip_check_token: true,
            footer_margin_none: true,
          },
          component: () => import("@/page/distributor/tour/front/home/1.0.2/index.vue"),
        },
      ],
    },
    {
      name: `distributor-registration-and-supplier-registration`,
      path: "/distributor",
      component: () => import(`@/page/supplier/registration/index.vue`),
      children: [
        {
          name: `distributor-registration`,
          path: "/distributor/registration",
          component: () =>
            import(
              `@/page/supplier/registration/distributorLogin/1.0.5/index.vue`
            ),
          meta: {
            skip_check_token: true,
          },
        },
        {
          name: `supplier-registration`,
          path: "/supplier/registration",
          component: () =>
            import(`@/page/supplier/registration/supplierLogin.vue`),
          meta: {
            skip_check_token: true,
          },
        },
        {
          name: `register-success`,
          path: "/register/success",
          component: () =>
            import(`@/page/supplier/registration/loginSuccess.vue`),
          meta: {
            skip_check_token: true,
          },
        },
        {
          name: `audit-message`,
          path: "/audit/message",
          component: () =>
            import(`@/page/supplier/registration/auditMessage.vue`),
          meta: {
            skip_check_token: true,
          },
        },
        {
          path: "/personage-register",
          name: "personage-register",
          component: () =>
            import("@/page/supplier/personageRegister/index.vue"),
          meta: {
            skip_check_token: true,
          },
        },
      ],
    },
  ];

  const routes = []
    .concat(routes_001)
    .concat(router_distributor_air_ticket_back)
    .concat(router_distributor_air_ticket_front)
    .concat(router_distributor_hotel_back)
    .concat(router_distributor_hotel_front)
    .concat(__routes);
  aRouter.addRoutes(routes);
  return routes;
};

export default add_routes;
